<template>
  <div>
    <button @click="switchWeek">{{ $t("route.Week") }}</button>
    <button @click="switchDay">{{ $t("route.Day") }}</button>
    <a-row>
      <a-col :xl="16" :lg="16" :md="24" :sm="24" :xs="24">
        <a-card>
          <vue3-chart-js
            ref="chartRef"
            :id="lineChart.id"
            :type="lineChart.type"
            :data="lineChart.data"
            :options="lineChart.options"
          />
        </a-card>
      </a-col>
      <a-col :xl="8" :lg="8" :md="16" :sm="16" :xs="24">
        <a-card :key="counterRender">
          <vue3-chart-js
            ref="doughnutChartRef"
            :id="doughnutChart.id"
            :type="doughnutChart.type"
            :data="doughnutChart.data"
            style="background-color: #ffffff"
          />
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
  import { ref } from "@vue/reactivity";
  import { onMounted, watch } from "vue";
  import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
  import { useI18n } from "vue-i18n";
  import useDashboardRepositories from "@/composables/useDashboardRepositories";
  import state from "@/state/dashboard";

  export default {
    name: "DashboardCharts",
    components: {
      Vue3ChartJs
    },
    data() {
      return {};
    },
    setup() {
      const { t, locale } = useI18n({ useScope: "global" });
      const chartRef = ref(null);
      const doughnutChartRef = ref(null);
      const counterRender = ref(0);
      const { newCalDataForChart, newCalDataForPie } = useDashboardRepositories();
      const { dashboardState } = state();

      const doughnutChart = ref({
        id: "doughnut",
        type: "doughnut",
        data: {
          labels: [
            t("route.InStore"),
            t("route.TransitToFactory"),
            t("route.InRepair"),
            t("route.TransitToStore"),
            t("route.WaitingForPickUp")
          ],
          datasets: [
            {
              backgroundColor: [
                "#41B883",
                "#E46651",
                "#00D8FF",
                "#DD1B16",
                "#000000"
              ],
              data: []
            }
          ]
        }
      });

      const lineChart = ref({
        id: "lineChart",
        type: "line",
        data: {
          labels: [1, 2, 3, 4, 5, 6, 7],
          datasets: [
            {
              type: "bar",
              label: t("route.Create"),
              data: [],
              fill: false,
              borderColor: "#00D8FF",
              tension: 0.5,
              backgroundColor: "#ff4d4f"
            }
          ]
        },
        options: {
          plugins: {}
        }
      });

      const switchWeek = () => {
        lineChart.value.data.datasets[0].data = dashboardState.wy;
        lineChart.value.data.labels = dashboardState.wx;
        chartRef.value.update(250);
      };

      const switchDay = () => {
        lineChart.value.data.datasets[0].data = dashboardState.y;
        lineChart.value.data.labels = dashboardState.x;
        chartRef.value.update(250);
      };

      onMounted(async () => {
        beforeRenderLogic()
        beforeRenderLogicPie()
      });

      const beforeRenderLogic = async (event) => {
        await newCalDataForChart()
        lineChart.value.data.datasets[0].data = dashboardState.y;
        lineChart.value.data.labels = dashboardState.x;
        chartRef.value.update(250);
      }

      const beforeRenderLogicPie = async (event) => {
        await newCalDataForPie()
        doughnutChart.value.data.datasets[0].data = dashboardState.pieData;
        doughnutChartRef.value.update(250); 
      }

      watch(locale, (newValue, oldValue) => {
        if (doughnutChartRef.value !== null && chartRef.value !== null) {
          doughnutChart.value.data.labels = [
            t("route.InStore"),
            t("route.TransitToFactory"),
            t("route.InRepair"),
            t("route.TransitToStore"),
            t("route.WaitingForPickUp"),
          ];
          doughnutChartRef.value.update();
          if (lineChart.data !== undefined) {
            lineChart.data.datasets[0].label = t("route.Create");
          }
          chartRef.value.update();
        }
      });

      return {
        chartRef,
        doughnutChartRef,
        lineChart,
        doughnutChart,
        switchDay,
        switchWeek,
        t,
        locale,
        counterRender,
        beforeRenderLogic,
        beforeRenderLogicPie
      };
    },
  };
</script>

<style lang="scss" scoped>
</style>